import React from "react";
import { Table, Input } from "reactstrap";
import { IDataTableProps } from "../../../interfaces/Index";
import "./DataTablePromoProductSearch.scss";

const DataTablePromoProductSearch: React.FunctionComponent<IDataTableProps> = (
  props: IDataTableProps
) => {
  const renderTableHeaders = () => {
    const {
      handleAllRecordSelection,
      tableHeaderData,
      allRecordsChecked,
    } = props;
    return tableHeaderData?.map((header, index) => {
      if (header.type === "checkbox") {
        return (
          <th key={index}>
            <Input
              type={header.type}
              checked={allRecordsChecked}
              onClick={handleAllRecordSelection}
            />
          </th>
        );
      }
      return <th key={index}>{header.text}</th>;
    });
  };

  const renderTableData = (data: any, index: number) => {
    const { tableBodyDataTypes, checkBoxClickHandler } = props;
    return tableBodyDataTypes.map((dataType, i) => {
      if (dataType.type === "checkbox") {
        return (
          <td key={i}>
            <Input
              key={index}
              type={dataType.type}
              checked={data[dataType.key]}
              onClick={(e) => checkBoxClickHandler?.(e, index)}
            />
          </td>
        );
      } else if (dataType.key === "itemAvailable") {
        return (
          <td key={i} title={data[dataType.key]} className="discount-applied">
            <div className="discount-type">
              {dataType.prepend}
              {data[dataType.key]}
            </div>
          </td>
        );
      }
      return (
        <td key={i} title={data[dataType.key]}>
          {dataType.prepend}
          {data[dataType.key]}
        </td>
      );
    });
  };

  const renderTableBody = () => {
    const { editRowHandler, tableBodyRowData, tableBodyDataTypes } = props;
    return tableBodyRowData.map((item, index) => {
      return (
        <tr
          key={index}
          className={
            (item.itemAvailable ? "disable-discount-applied" : "") ||
            (item.isChecked ? "record-selected" : "") ||
            "with-sub-category"
          }
          onClick={(e) => editRowHandler?.(e, index)}
        >
          {tableBodyDataTypes &&
            tableBodyDataTypes.length > 0 &&
            renderTableData(item, index)}
        </tr>
      );
    });
  };

  const renderTableFooter = () => {
    const { tableFooterData, noSearchResultFlag, tableBodyRowData } = props;
    return (
      noSearchResultFlag &&
      tableBodyRowData &&
      tableBodyRowData.length === 0 && (
        <tr>
          <div className="no-search-found">
            <img src={tableFooterData?.imgSrc} alt={tableFooterData?.imgAlt} />
            <div className="no-search-title">{tableFooterData?.title}</div>
            <div className="no-search-sub-title">
              {tableFooterData?.subTtitle}
            </div>
          </div>
        </tr>
      )
    );
  };

  return (
    <Table
      borderless
      striped
      className="promo-product-table"
      id={props.tableId}
    >
      {props.tableHeaderData && props.tableHeaderData.length > 0 && (
        <thead>
          <tr>{renderTableHeaders()}</tr>
        </thead>
      )}
      <tbody>
        {props.tableBodyRowData &&
          props.tableBodyRowData.length > 0 &&
          renderTableBody()}
      </tbody>
      {props.tableFooterData && (
        <tfoot>
          <tr>{renderTableFooter()}</tr>
        </tfoot>
      )}
    </Table>
  );
};

DataTablePromoProductSearch.defaultProps = {
  tableId: "tableId",
  tableHeaderData: null,
  tableFooterData: null,
  noSearchResultFlag: false,
  allRecordsChecked: false,
};

export default DataTablePromoProductSearch;
